import { render, staticRenderFns } from "./MarketingChannelOption.vue?vue&type=template&id=074b7332&scoped=true&"
import script from "./MarketingChannelOption.vue?vue&type=script&lang=js&"
export * from "./MarketingChannelOption.vue?vue&type=script&lang=js&"
import style0 from "./MarketingChannelOption.vue?vue&type=style&index=0&id=074b7332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b7332",
  null
  
)

export default component.exports